'use client';

import { getCloudfrontSignedUrl } from '@3fourteen/core';
import { useQuery } from '@tanstack/react-query';
import { mainBugsnag } from 'helpers/bugsnag';

export function useSignedCloudfrontUrl(key = '') {
  const {
    data: url,
    error,
    isLoading,
  } = useQuery({
    queryKey: [key],
    queryFn: async () => {
      return await getCloudfrontSignedUrl({ key });
    },
    enabled: !!key,
    throwOnError: (error, query) => {
      mainBugsnag.notify(error, (event) => {
        event.context = 'useSignedCloudfrontUrl()';
        event.addMetadata('Key', {
          key,
          query,
        });
      });

      return false;
    },
  });

  return {
    isLoading,
    url,
    error,
  };
}
